var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQueue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.99609,
    y: 7,
    width: 8,
    height: 8,
    rx: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.99609,
    y: 7,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#979797",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99609 4C4.44381 4 3.99609 4.44772 3.99609 5V11C3.99609 11.5523 4.44381 12 4.99609 12C5.54838 12 5.99609 11.5523 5.99609 11V7C5.99609 6.44772 6.44381 6 6.99609 6H10.9961C11.5484 6 11.9961 5.55228 11.9961 5C11.9961 4.44772 11.5484 4 10.9961 4H4.99609Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99609 4C4.44381 4 3.99609 4.44772 3.99609 5V11C3.99609 11.5523 4.44381 12 4.99609 12C5.54838 12 5.99609 11.5523 5.99609 11V7C5.99609 6.44772 6.44381 6 6.99609 6H10.9961C11.5484 6 11.9961 5.55228 11.9961 5C11.9961 4.44772 11.5484 4 10.9961 4H4.99609Z",
    fill: "#979797",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99609 1C1.44381 1 0.996094 1.44772 0.996094 2V8C0.996094 8.55228 1.44381 9 1.99609 9C2.54838 9 2.99609 8.55228 2.99609 8V4C2.99609 3.44772 3.44381 3 3.99609 3H7.99609C8.54838 3 8.99609 2.55228 8.99609 2C8.99609 1.44772 8.54838 1 7.99609 1H1.99609Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueue);
export default __webpack_public_path__ + "static/media/queue.70fac0708ae58db9c915bb0991a6e49f.svg";
export { ForwardRef as ReactComponent };